import React, { useEffect, useState } from 'react';
import useMedia from 'use-media';
import { Label } from '../../atoms/RTCC/label';
import { PullDownOptionForm } from '../../molecules/RTCC/pullDownOptionForm';

export const BirthDateForm = (props) => {
    const { handleGuestInfo } = props;

    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });

    const [year, setYear] = useState([]);
    const [month, setMonth] = useState([]);
    const [day, setDay] = useState([]);

    // const [yearNum, setYearNum] = useState("0000");
    // const [monthNum, setMonthNum] = useState("00");
    // const [dayNum, setDayNum] = useState("00");

    useEffect(() => {
        let yearList = [{ value: "1900", id: "1900" }];
        for (let i = props.firstYear + 1; i <= new Date().getFullYear(); i++) {
            let yearObj = {
                value: i,
                id: i,
            }
            yearList.push(yearObj);
        }
        setYear(yearList);
        setMonth([
            { value: "01", id: "01" }, { value: "02", id: "02" },
            { value: "03", id: "03" }, { value: "04", id: "04" }, { value: "05", id: "05" },
            { value: "06", id: "06" }, { value: "07", id: "07" }, { value: "08", id: "08" },
            { value: "09", id: "09" }, { value: "10", id: "10" }, { value: "11", id: "11" },
            { value: "12", id: "12" }
        ]);
        let dayList = [];
        for (let i = 1; i <= 31; i++) {
            let dayObj = {
                value: i <= 9 ? "0" + i : i,
                id: i <= 9 ? "0" + i : i,
            }
            dayList.push(dayObj);
        }
        setDay(dayList);
    }, []);

    // 月末日設定
    const setLastDay = (year, month) => {
        const lastDay = new Array("", 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
        if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
            lastDay[2] = 29;
        }
        return lastDay[month];
    }

    // 年月プルダウン変更後の処理
    const handlePullDown = () => {
        let year = document.getElementById(props.yearId).value;
        let month = document.getElementById(props.monthId).value;
        let day = document.getElementById(props.dayId).value;
        let days = [];
        let lastDay = 31;
        if (year !== "0000" && month !== "00") {
            lastDay = setLastDay(Number(year), Number(month));
        }
        for (let i = 1; i <= lastDay; i++) {
            let dayObj = {
                value: i <= 9 ? "0" + i : i,
                id: i <= 9 ? "0" + i : i,
            }
            days.push(dayObj);
        }
        setDay(days);
        if (handleGuestInfo) {
            handleGuestInfo();
        }
    }

    return (
        <div >
            <Label label={props.label} className={props.labelClassName} />
            <div style={props.pullDownAreaStyle}>
                <div className={props.birthDateClassName}>
                    <PullDownOptionForm
                        wrapClassName={props.wrapClassName}
                        labelClassName={props.labelClassName}
                        className={props.className}
                        data={year}
                        state={props.yearNum}
                        onChange={handlePullDown}
                        id={props.yearId}
                    />
                    <Label
                        label={props.yearTitle}
                        className={props.birthDateLabel}
                    />
                </div>
                <div className={props.birthDateClassName}>
                    <PullDownOptionForm
                        wrapClassName={props.wrapClassName}
                        labelClassName={props.labelClassName}
                        className={props.className}
                        data={month}
                        state={props.monthNum}
                        onChange={handlePullDown}
                        id={props.monthId}
                    />
                    <Label
                        label={props.monthTitle}
                        className={props.birthDateLabel}
                    />
                </div>
                <div className={props.birthDateClassName}>
                    <PullDownOptionForm
                        wrapClassName={props.wrapClassName}
                        labelClassName={props.labelClassName}
                        className={props.className}
                        data={day}
                        state={props.dayNum}
                        onChange={handlePullDown}
                        id={props.dayId}
                    />
                    <Label
                        label={props.dayTitle}
                        className={props.birthDateLabel}
                    />
                </div>
            </div>
        </div>
    );
}
